import { useEffect, useState } from 'react';

export function useCreatePreview(subject, mailer_content, tone, variability, subject_variability, campaign, prompt_inject, language) {
  const [preview, setPreview] = useState();
  useEffect(() => {
    const doFetch = async () => {
      console.log("useCreatePreview: Starting preview creation");
      const fd = new FormData();
      fd.append('tone', tone);
      fd.append('variability', variability);
      fd.append('subject_variability', subject_variability);
      fd.append('mailer_content', mailer_content);
      fd.append('prompt_inject', prompt_inject);
      fd.append('subject', subject);
      if (language) {
        fd.append('language', language);
      }
      if (campaign) {
        fd.append('campaign_id', campaign._id);
      }

      try {
        const d = await fetch(`/api/v1/campaign/preview`, {method: 'POST', body: fd});
        console.log("useCreatePreview: Response status:", d.status);
        const data = await d.json();
        console.log("useCreatePreview: Response data:", data);
        // Note - this is only the preview ID. We will need to poll for its contents.
        setPreview(data['preview']);
        console.log("useCreatePreview: Set preview ID to:", data['preview']);
      } catch (error) {
        console.error("useCreatePreview: Error creating preview:", error);
      }
    };
    doFetch();
    // eslint-disable-next-line
  }, []);
  return preview;
}
